import trash from './trash';
import phone from './phone';
import edit from './edit';
import zoomin from './zoomin';
import zoomout from './zoomout';
import print from './print';
import file from './file';
import home from './home';
import user from './user';
import search from './search';
import logout from './logout';
import login from './login';
import settings from './settings';
import show from './show';
import hide from './hide';
import download from './download';
import info from './info';
import add from './add';
import remove from './remove';
import mail from './mail';
import calendar from './calendar';
import chevronDown from './chevronDown';
import chevronUp from './chevronUp';
import chevronLeft from './chevronLeft';
import chevronRight from './chevronRight';
import payment from './payment';
import spinner from './spinner';
import star from './star';
import dropdown from './dropdown';
import supplier from './supplier';
import resources from './resources';
import skipLastPage from './skipLastPage';
import skipFirstPage from './skipFirstPage';
import rightArrow from './rightArrow';
import leftArrow from './leftArrow';
import customer from './customer';
import closeSidebar from './closeSidebar';
import notification from './notification';
import confirm from './confirm';
import cancel from './cancel';
import nextPage from './nextPage';
import previousPage from './previousPage';
import eye from './eye';
import sun from './sun';
import moon from './moon';
import google from './google';
import facebook from './facebook';
import attention from './attention';
import minus from './minus';
import cancelEye from './cancelEye';
import threePoints from './threePoints';
import timesheet from './timesheet';
import question from './question';
import reload from './reload';
import lock from './lock';
import unlock from './unlock';

export interface IconsProps {
  iconName: IconNames;
  className?: string;
}

export const ICON_NAMES = [
  'trash',
  'phone',
  'edit',
  'zoomin',
  'zoomout',
  'print',
  'file',
  'home',
  'user',
  'search',
  'logout',
  'login',
  'settings',
  'show',
  'hide',
  'download',
  'info',
  'add',
  'remove',
  'mail',
  'calendar',
  'chevronDown',
  'chevronUp',
  'chevronLeft',
  'chevronRight',
  'payment',
  'spinner',
  'star',
  'dropdown',
  'supplier',
  'resources',
  'skipLastPage',
  'skipFirstPage',
  'rightArrow',
  'leftArrow',
  'customer',
  'closeSidebar',
  'notification',
  'confirm',
  'cancel',
  'nextPage',
  'previousPage',
  'eye',
  'sun',
  'moon',
  'google',
  'facebook',
  'attention',
  'minus',
  'cancelEye',
  'threePoints',
  'question',
  'timesheet',
  'reload',
  'unlock',
  'lock',
] as const;

export type IconNames = (typeof ICON_NAMES)[number];

const index = {
  trash,
  phone,
  edit,
  zoomin,
  zoomout,
  print,
  file,
  home,
  user,
  search,
  logout,
  login,
  settings,
  show,
  hide,
  download,
  info,
  add,
  remove,
  mail,
  calendar,
  chevronDown,
  chevronUp,
  chevronLeft,
  chevronRight,
  payment,
  spinner,
  star,
  dropdown,
  supplier,
  resources,
  skipLastPage,
  skipFirstPage,
  rightArrow,
  leftArrow,
  customer,
  closeSidebar,
  notification,
  confirm,
  cancel,
  nextPage,
  previousPage,
  eye,
  sun,
  moon,
  google,
  facebook,
  attention,
  minus,
  cancelEye,
  threePoints,
  timesheet,
  question,
  reload,
  unlock,
  lock,
};

export const IconSVG = ({ iconName, className }: IconsProps) => {
  const Icon = index[iconName];
  return <Icon className={className} />;
};

IconSVG.displayName = 'IconSvg';

export default IconSVG;
